import { Trans } from '@lingui/macro'
import { Box, FormLabel, Grid, Typography } from '@mui/material'
import { useFormikContext } from 'formik'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'
import { ResourcesDetailsButton, ResourcesDetailsLightButton } from '../resources/ResourcesDetailsCard/Button'
import { FirstLoginFlowFormikProps } from './index'
import { InfoBanner } from './InfoBanner'
import { JobDialog } from './JobDialog'
import OrganizationLine from './OrganizationLine'

export const OrganizationConnectResults = () => {
  const { enqueueSnackbar } = useSnackbar()

  const [displayJobDialog, setDisplayJobDialog] = useState(false)

  const avaliableOrganizations = useSelector(
    (state: RootStateOrAny) => state.avaliableOrganizations
  )

  const {
    values, handleChange, handleBlur, setFieldValue, validateForm
  } = useFormikContext<FirstLoginFlowFormikProps>()

  const joinOrganizationIds = values.joinOrganizationIds

  const onClickRequestToConnect = () => {
    setDisplayJobDialog(true)
  }

  const onClickModifySearch = () => {
    setFieldValue('results', null)
    setFieldValue('selectedOrganizationId', null)
  }

  const onClickCreateNewOrganization = () => {
    // setFieldValue('results', null)
    setFieldValue('displayOrganizationConnectDialog', false)
    setFieldValue('displayCreateNewOrganizationDialog', true)
    setFieldValue('organization.name', values.search)
  }

  return (
    <>
      <JobDialog display={displayJobDialog} setDisplay={setDisplayJobDialog} />

      <FormLabel sx={{ textAlign: 'center', fontSize: '24px', lineHeight: '28px', mb: '54px', mt: '-32px' }}>
        <Trans>FIRST_LOGIN_FLOW_CONNECT_TO_ORGANIZATION_LABEL</Trans>
      </FormLabel>

      <FormLabel sx={{ mb: '14px' }}>
        <Trans>FIRST_LOGIN_FLOW_FIND_YOUR_ORGANIZATION_LABEL</Trans>
      </FormLabel>

      <InfoBanner
        sx={{ mb: '14px' }}
        title={<Trans>FIRST_LOGIN_FLOW_FIND_YOUR_ORGANIZATION_BANNER_TITLE</Trans>}
        description={<Trans>FIRST_LOGIN_FLOW_CREATE_ORGANIZATION_BANNER_DESCRIPTION</Trans>}
      />

      {values.results.length > 1 && <Typography
        variant='body2'
        sx={{ color: 'primary.main', fontSize: '16px', lineHeight: '18px', fontWeight: '700', mb: '16px', mt: '29px' }}
                                    >
        <Trans>FIRST_LOGIN_FLOW_MULTIPLE_ORGANIZATION_RESULTS_LABEL</Trans>
      </Typography>}

      <Box className='flex flex-column' sx={{ gap: '8px' }}>
        {values.results.map((result, index) => {
          const isAlreadyConnected = avaliableOrganizations.length > 0 && avaliableOrganizations.some(org => org.id === result.Id)
          const hasJoinRequest =
            (joinOrganizationIds != null) &&
            joinOrganizationIds.includes(result.Id)

          return (
            <OrganizationLine
              key={index}
              text={result.Name}
              id={result.Id}
              isSelected={values.selectedOrganizationId === result.Id}
              onClick={isAlreadyConnected || hasJoinRequest
                ? undefined
                : async (id: string) => await setFieldValue('selectedOrganizationId', id)}
              tooltip={isAlreadyConnected
                ? <Trans>FIRST_LOGIN_FLOW_ALREADY_CONNECTED_TO_ORGANIZATION_TOOLTIP</Trans>
                : hasJoinRequest
                  ? <Trans>FIRST_LOGIN_FLOW_ALREADY_REQUESTED_TO_CONNECT_TO_ORGANIZATION_TOOLTIP</Trans>
                  : undefined}
            />
          )
        })}
      </Box>

      <Grid container wrap='nowrap' sx={{ gap: '16px', mt: '16px', mb: '16px' }}>
        <Grid item xs>
          <ResourcesDetailsButton
            disabled={!values.selectedOrganizationId}
            text={<Trans>FIRST_LOGIN_FLOW_REQUEST_TO_CONNECT_BUTTON</Trans>}
            onClick={onClickRequestToConnect}
            sx={{ width: '100%' }}
          />
        </Grid>
        <Grid item sx={{ minWidth: '150px' }}>
          <ResourcesDetailsLightButton
            text={<Trans>FIRST_LOGIN_FLOW_MODIFY_SEARCH_BUTTON</Trans>}
            onClick={onClickModifySearch}
            sx={{ width: '100%' }}
          />
        </Grid>
      </Grid>

      <ResourcesDetailsLightButton
        sx={{ width: '100%' }}
        text={<Trans>FIRST_LOGIN_FLOW_CREATE_NEW_ORGANIZATION_BUTTON</Trans>}
        onClick={onClickCreateNewOrganization}
      />
    </>
  )
}
